import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'
const Footer = () => {
  return (
    <footer className="footer">
    <div className="footer-content">
      <div className="footer-title">
        <Link to="/"><img src="logo.png" alt="aruba Flag" className="flag-icon" /></Link>
        <h3>Aruba ED Card</h3>
      </div>
      <p className="disclaimer">
      Disclaimer: This website is operated by an independent third-party service provider and is not affiliated with, endorsed by, or operated on behalf of the Government of Aruba.
      </p>
      <hr />
      <div className="footer-bottom">
        <p>© 2025 aruba-ed.com. All Rights Reserved</p>
        <div className="footer-links">
          <Link to="/terms">Terms and Conditions</Link>
          <Link to="/privacy">Privacy Policy</Link>
        </div>
      </div>
    </div>
  </footer>
  )
}

export default Footer